var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertificateProgramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8 0C0.801 0 0 0.749474 0 1.68421V10.1053C0 10.5519 0.189642 10.9803 0.527208 11.2962C0.864773 11.612 1.32261 11.7895 1.8 11.7895H9V16L11.7 13.4737L14.4 16V11.7895H16.2C16.6774 11.7895 17.1352 11.612 17.4728 11.2962C17.8104 10.9803 18 10.5519 18 10.1053V4.21053V2.52632V1.68421C18 1.23753 17.8104 0.809145 17.4728 0.493294C17.1352 0.177443 16.6774 0 16.2 0H12.6H1.8ZM9 1.68421L11.7 3.36842L14.4 1.68421V4.63158L17.1 5.89474L14.4 7.15789V10.1053L11.7 8.42105L9 10.1053V7.15789L6.3 5.89474L9 4.63158V1.68421ZM1.8 1.68421H6.3V3.36842H1.8V1.68421ZM1.8 5.05263H4.5V6.73684H1.8V5.05263ZM1.8 8.42105H6.3V10.1053H1.8V8.42105Z",
    fill: "#AD7915"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateProgramIcon);
export default __webpack_public_path__ + "static/media/certificate_program_icon.edf6b9ae6bfe4cec3ac5126ef931e000.svg";
export { ForwardRef as ReactComponent };